exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__shader___1TzJm{z-index:49;width:150vw;height:150vh;background:#9e7fc9;opacity:.7;position:fixed;top:0;left:0}.index-module__shader___1TzJm.index-module__purple-dark___1Hat5{background:#46469a}.index-module__shader___1TzJm.index-module__purple___2Ua5v{background:#9e7fc9}.index-module__shader___1TzJm.index-module__yellow___pYntR{background:#fac15c}.index-module__shader___1TzJm.index-module__blue___1DQZW{background:#35b6dd}", ""]);

// exports
exports.locals = {
	"shader": "index-module__shader___1TzJm",
	"purple-dark": "index-module__purple-dark___1Hat5",
	"purple": "index-module__purple___2Ua5v",
	"yellow": "index-module__yellow___pYntR",
	"blue": "index-module__blue___1DQZW"
};